module.exports = __webpack_public_path__ + "img/yt.47edf081.svg";